<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <!-- LOHNSTEUERLICHE BETRIEBSSTÄTTE -->
  <div class="mb-5x">

    <div class="d-flex justify-content-between mb-2x">
      <h3>
        {{ 'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.LOHNSTEUERLICHE_BETRIEBSSTAETTE.TITEL' | translate }}
      </h3>
      <common-ui-daten-uebernahme (picked)="onBetriebstaettePicked($event)" [itemTemplate]="datenUebernahmeBetriebstaette"
                                  [items]="betriebstaetten" [readonly]="readonly"
                                  context="Betriebstaette"></common-ui-daten-uebernahme>
    </div>

    <p class="mb-2x">
      {{'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.LOHNSTEUERLICHE_BETRIEBSSTAETTE.HINWEIS' | translate}}
    </p>

    <div class="form-row">
      <label class="col-sm-4 col-form-label" for="betriebstaetteBezeichnung">
        {{ 'COMMON_UI.FRAGEBOGEN.LOHNSTEUER.LOHNSTEUERLICHE_BETRIEBSSTAETTE.BEZEICHNUNG' | translate }}
      </label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="betriebstaetteBezeichnung{{objectId}}"
               formControlName="betriebstaetteBezeichnung" id="betriebstaetteBezeichnung"
               type="text" utilsCheckValidity
               utilsControlState
               utilsValidationMessage/>

      </div>
    </div>

    <common-ui-adresserfassung
      [(inlandsadresse)]="data.betriebstaetteInlandsadresse"
      [disableAuslandsadresse]="true"
      [disablePostfachadresse]="true"
      [noAddressRequired]="true"
      [optionalInlandsadresse]="true"
      [readonly]="readonly">
    </common-ui-adresserfassung>

  </div>
</form>

<ng-template #datenUebernahmeBetriebstaette let-item="item">
  <h4 class="list-group-item-heading">{{item?.bezeichnung}}</h4>
  <p class="list-group-item-text">
    {{item?.inlandsadresse?.strasse}} {{item?.inlandsadresse?.hausnummer}} {{item?.inlandsadresse?.hausnummernzusatz}}
    <br *ngIf="item?.inlandsadresse?.adressergaenzung">{{item?.inlandsadresse?.adressergaenzung}}
    <br>{{item?.inlandsadresse?.postleitzahl}} {{item?.inlandsadresse?.ort}}</p>
</ng-template>
